import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrearIntermediarioComponent } from '../crear-intermediario/crear-intermediario.component'

@Component({
    selector: 'edit-user-modal',
    templateUrl: './edit-user-modal.component.html',
  })
  export class EditUserBrokerModal implements OnInit {

    editUserForm: FormGroup;
    public mask = ['(', '+', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

    constructor(
      public dialogRef: MatDialogRef<CrearIntermediarioComponent>,
      @Inject(MAT_DIALOG_DATA) public data,
      private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        const data = this.data.data
        // console.log(data);
        this.editUserForm = this.fb.group({
            name: [data.names, Validators.required],
            lastname: [data.lastnames, Validators.required],
            id: [data.id, Validators.required],
            userPhone: [data.phone, Validators.required],
            userEmail: [data.email, Validators.compose([Validators.required, Validators.email])],
        })
    }

    onNoClick(form): void {
        if (form) {
            if (form.invalid) {
                const controls = form.controls;
                Object.keys(controls).forEach(controlName =>
                    controls[controlName].markAsTouched()
                );
                return;
            } else {
                this.dialogRef.close({value: form.value, index: this.data.data.index});
            }
        } else {
            this.dialogRef.close(form);
        }
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.editUserForm.controls[controlName];
        if (!control) {
            return false;
        }

        const result = control.hasError(validationType) && (control.dirty || control.touched);
        return result;
    }
  }
